import { render } from "./InstructionPage.vue?vue&type=template&id=42d355f8&scoped=true"
import script from "./InstructionPage.vue?vue&type=script&lang=js"
export * from "./InstructionPage.vue?vue&type=script&lang=js"

import "./InstructionPage.vue?vue&type=style&index=0&id=42d355f8&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/topik-vue/topik-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42d355f8"]])

export default __exports__